import { useQuery } from "react-query";
import axiosInstance from "./axiosInstance";
import { NotificationlistRes } from "../../types/ResType";

export const useNotificationList = () => {
  return useQuery<NotificationlistRes, Error>(
    ["users/list-broadcast-notification"],
    async () => {
      const response = await axiosInstance.post<NotificationlistRes>(
        "users/list-broadcast-notification",
        {},
      );
      return response.data;
    },
    {
      staleTime: Infinity,
      cacheTime: Infinity,
    },
  );
};